import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/tools/fruit-tree-planner/FruitTreePlannerClientShell.tsx");
